import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { EligibilityType } from "./EligibilityType";
import type { InvalidSignupReasonDTOBase } from "./InvalidSignupReasonDTOBase";
import type { InvalidSignupReportStaff } from "./InvalidSignupReportStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class InvalidSignupReasonStaff implements InvalidSignupReasonDTOBase, TrackedModernBase {
  constructor(public readonly reasonId: number, public readonly reportId: InvalidSignupReportStaff | null, public readonly checkType: EligibilityType, public readonly message: string | null, public readonly firstDetectedAt: Date, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.reportIdLoaded = this.reportId != null;
    this.reportIdCached = this.reportId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private reportIdLoaded: boolean;
  private reportIdCached: InvalidSignupReportStaff | null;
  async reportIdLazy(): Promise<InvalidSignupReportStaff> {
    if (!this.reportIdLoaded) {
      this.reportIdCached = await this.cbiServiceContext!.reportService().getInvalidSignupReasonStaffReportId(this.reasonId);
      this.reportIdLoaded = true;
    }
    return this.reportIdCached!;
  }
}
